const NANOSECONDS_IN_MILLISECONDS = 1000000;
function millisecondsToNanoseconds(milliseconds) {
    return Math.round(milliseconds * NANOSECONDS_IN_MILLISECONDS);
}
function nanosecondsToMilliseconds(nanoseconds) {
    return Math.round(nanoseconds / NANOSECONDS_IN_MILLISECONDS);
}

export { millisecondsToNanoseconds, nanosecondsToMilliseconds };
